var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "square-card", attrs: { "no-body": "" } },
    [
      _c(
        "b-card-body",
        { staticClass: "d-flex align-items-center p-5" },
        [
          _c(
            "b-avatar",
            {
              staticClass: "mr-2",
              attrs: { variant: "light-" + _vm.color, size: "100" },
            },
            [
              _c(_vm.iconComponent, {
                tag: "component",
                attrs: { svgColor: _vm.colorHex, width: _vm.width },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "truncate" }, [
            _c("h4", { staticClass: "mb-25 font-weight-bolder" }, [
              _vm._v(_vm._s(_vm.statistic)),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.statisticTitle))]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }